module.exports = __webpack_public_path__ + "assets/chevin-thin.2f2f0b44521019eb3d3df85c50dbd131.woff";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/OP/chevin-thin.woff
// module id = 135
// module chunks = 0